module.exports = __webpack_public_path__ + "static/img/gulshan-logo.c17de27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gulshan-logo.png
// module id = FXAk
// module chunks = 1